import React from 'react'

const PageLoader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader"></div>
    </div>
  )
}

export default PageLoader